"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_core_1 = require("owa-options-core");
var owa_options_controls_1 = require("owa-options-controls");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Label_1 = require("office-ui-fabric-react/lib/Label");
var updateTxpFlag_1 = require("../actions/updateTxpFlag");
var getTxpFlagInfo_1 = require("../utils/getTxpFlagInfo");
var TxpEventsPanel = /** @class */ (function (_super) {
    tslib_1.__extends(TxpEventsPanel, _super);
    function TxpEventsPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * On change handler for the OptionsCheckbox
         */
        _this.updateFlagFromCheckbox = function (flag) { return function (ev, checked) {
            updateTxpFlag_1.default(flag, checked);
        }; };
        return _this;
    }
    TxpEventsPanel.prototype.render = function () {
        var _this = this;
        var _a = this.props, formFlags = _a.formFlags, mailboxCalendarConfiguration = _a.mailboxCalendarConfiguration, flagsDisabled = _a.flagsDisabled;
        return (React.createElement("div", null,
            React.createElement(Label_1.Label, null, owa_options_strings_1.default.options_txp_addEventsTitle),
            getTxpFlagInfo_1.EventsInOptionsPageInOrder.map(function (eventType) {
                if (!getTxpFlagInfo_1.isEventTypeEnabled(eventType)) {
                    return null;
                }
                var checked = owa_options_core_1.getFallbackValueIfNull(formFlags[eventType], mailboxCalendarConfiguration[eventType]);
                return (React.createElement(owa_options_controls_1.OptionsCheckbox, { checked: checked, disabled: flagsDisabled, onChange: _this.updateFlagFromCheckbox(eventType), label: getTxpFlagInfo_1.getLabelForTxpFlag(eventType) }));
            })));
    };
    TxpEventsPanel = tslib_1.__decorate([
        mobx_react_1.observer
    ], TxpEventsPanel);
    return TxpEventsPanel;
}(React.Component));
exports.default = TxpEventsPanel;
//# sourceMappingURL=TxpEventsPanel.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-txp-option/lib/components/TxpEventsPanel.js
// module id = 5270
// module chunks = 2